var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [_vm._m(0), _vm._v(" "), _c("app-backend-footer")],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid xyz" }, [
      _c("div", { staticClass: "page-header-top-container" }, [
        _c("div", { staticClass: "page-name" }, [_vm._v("Profile")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "admin-page-content" }, [
        _c("div", { staticClass: "user-profile-main-section col-12 float-l" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "user-profile-top-section float-l col-12 default-bx-shadow bg-color-ffffff"
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "user-image float-l" }, [
                    _c("img", {
                      attrs: {
                        src: "/static/images/avtar-img-1.jpg",
                        alt: "User Name"
                      }
                    }),
                    _vm._v(" "),
                    _c("a", { attrs: { href: "#" } }, [
                      _c("i", {
                        staticClass: "hi-icon icon-abmnew-file user-edit-icon"
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-detail-section float-l" }, [
                    _c(
                      "h1",
                      {
                        staticClass:
                          "color-71aa3f heading-text-28 line-height-32 float-l width-full font-text-regular-san mb-0"
                      },
                      [_vm._v(" Elizabeth Lizarraga ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "h6",
                      {
                        staticClass:
                          "color-7a7a7a heading-text-15 line-height-20 float-l width-full font-text-regular-san mb-0"
                      },
                      [_vm._v(" Director of Human Resources, VVG ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass:
                          "user-join-date float-l width-full color-7a7a7a heading-text-15 line-height-20 float-l width-full font-text-regular-san mb-0 pt-15"
                      },
                      [
                        _vm._v(" Joining on "),
                        _c("span", { staticClass: "font-text-bold-san" }, [
                          _vm._v(" 23rd August, 2016 ")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-detail-btm float-l col-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "user-detail-sec float-l col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-30"
                        },
                        [
                          _c("h6", { staticClass: "user-title-top" }, [
                            _vm._v(" Address ")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              " 795 Folsom Ave, Suite 600, San Francisco, CADGE 94107 "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "user-detail-sec float-l col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-30"
                        },
                        [
                          _c("h6", { staticClass: "user-title-top" }, [
                            _vm._v(" Email Address ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "mailto:elizabeth.lizarranga@vvg.com"
                              }
                            },
                            [_vm._v(" elizabeth.lizarranga@vvg.com ")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "user-detail-sec float-l col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-30"
                        },
                        [
                          _c("h6", { staticClass: "user-title-top" }, [
                            _vm._v(" Phone # ")
                          ]),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", [
                              _c("div", { staticClass: "detail-title" }, [
                                _vm._v(" Mobile:")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail-sec" }, [
                                _vm._v(" + 800 123 5678 ")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("div", { staticClass: "detail-title" }, [
                                _vm._v(" Landline: ")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail-sec" }, [
                                _vm._v(" + (123) 456-7890 ")
                              ])
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "user-detail-sec float-l col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-30"
                        },
                        [
                          _c("h6", { staticClass: "user-title-top" }, [
                            _vm._v(" Roles ")
                          ]),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", [
                              _vm._v(
                                "\n                                                Project Manager\n                                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "\n                                                Administrator\n                                            "
                              )
                            ])
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "user-profile-top-section float-l col-12 default-bx-shadow bg-color-ffffff mt-50"
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("h6", { staticClass: "user-title-top" }, [
                    _vm._v(" Bio ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass:
                        "user-join-date float-l width-full color-7a7a7a heading-text-15 line-height-20 float-l width-full font-text-regular-san mb-0 pt-8"
                    },
                    [
                      _vm._v(" Born on "),
                      _c("span", { staticClass: "font-text-bold-san" }, [
                        _vm._v(" 9th April, 1990 ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass:
                        "color-7a7a7a heading-text-16 line-height-22 float-l width-full font-text-regular-san mb-0 pt-25"
                    },
                    [
                      _vm._v(
                        " Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. "
                      )
                    ]
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d0b1749", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0b1749","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile.vue
// module id = null
// module chunks = 